<template>
    <header class="header">
        <div class="allnav">
            <div class="in_allnav">
                <span @click="trainEnter" v-show="!isLogin">培训机构入驻</span>
                <span style="float:right;position:relative;">
                    <span @click="goenter" v-show="!isLogin">培训机构入口</span>
                    <span style="margin-left:20px;" @click="stuenter" v-show="!isLogin">学员入口</span>
                    <span class="islogin" v-show="isLogin">
                        <router-link class="btn" :to="{'name': 'study'}">
                            <el-avatar
                                style="width:30px;height:30px;margin-top:5px;"
                                :src="user.picture"
                            ></el-avatar>
                            <span style="margin-left:10px;">{{user.realName || user.name}}</span>
                        </router-link>
                        <span class="logout" @click="logout">[退出]</span>
                    </span>
                </span>
            </div>
        </div>
        <div class="header-cont page-width">
            <div class="header-logo" @click="toIndex" style="cursor: pointer;">
                <pic :src="platform.logo" height="120px" width="120px" />
                <span class="logo_title" ref="lt">{{ platform.platformName }}</span>
            </div>

            <div class="search">
                <!-- <div class="search-selected"> -->
                <!-- <i class="edufont e-icon-arrowright"></i>
                <span>课程</span>-->
                <select name="selected" id="select" v-model="selected">
                    <option
                        v-for="item in optionList"
                        :value="item.id"
                        :key="item.id"
                    >{{ item.name }}</option>
                </select>
                <div style="position: absolute;left: 70px;top: 9px;z-index:1;">
                    <pic style="width: 12px;height: 10px;" :src="edit" alt />
                </div>
                <div class="search-text">
                    <input
                        type="input"
                        v-model="topKeyword"
                        placeholder="请输入关键字..."
                        @keyup.enter="search"
                    />
                </div>
                <div class="search-button">
                    <input type="button" value="搜索" style="cursor: pointer;" @click="search" />
                </div>
            </div>
            <div class="clear"></div>
            <nav class="header-nav">
                <ul>
                    <li class="head-nav-allbtn">
                        <a @mouseenter="mouseEnter" @mouseleave="mouseLeave">
                            <div class="header-down">
                                <router-link :to="{'name': 'index'}" tag="span" class="btn">全部课程</router-link>
                                <i class="down">
                                    <img src="../assets/images/down.png" alt />
                                </i>
                                <!-- <i class="edufont e-icon-Listmode"></i> -->
                            </div>
                        </a>
                    </li>
                    <li
                        class="box"
                        v-for="(t,index) in tabs"
                        :key="index"
                        :class="{box2: tab === t.id}"
                    >
                        <router-link class="btn" :to="{'name': t.id}">{{ t.name }}</router-link>
                    </li>
                </ul>
            </nav>
        </div>
    </header>
</template>
<script>
import edit from '../assets/images/arrow.png'
export default {
    name: 'top',
    props: ['keyword', 'tab'],
    data() {
        return {
            selected: 1,
            optionList: [
                { name: '课程', id: 1 },
                { name: '机构', id: 2 },
                { name: '班级', id: 3 }
            ],
            show: '',
            isShow: true,
            seen: false,
            disabled: true,
            topKeyword: '',
            active: '',
            tabs: [
                {
                    id: 'school',
                    name: '培训机构'
                },
                {
                    id: 'skill',
                    name: '技能培训'
                },
                {
                    id: 'teacher',
                    name: '技能大师'
                },
                {
                    id: 'news',
                    name: '行业资讯'
                },
                {
                    id: 'policy',
                    name: '政策法规'
                },
                {
                    id: 'study',
                    name: '我的学习'
                }
            ],
            edit: edit,
            platform: this.$store.state.platform
        }
    },
    computed: {
        user() {
            return this.$store.state.user || {}
        },
        isLogin() {
            return this.$store.state.user != null
        }
    },
    created() {
        if (localStorage.getItem('select')) {
            this.selected = localStorage.getItem('select')
        } else {
            this.selected = this.optionList[0].id
        }
    },
    mounted(){
        var maxHeight = this.$refs.lt.offsetHeight;
        var size = maxHeight;
        do {
            this.$refs.lt.style.fontSize=(size--)+"px";
            if(size<14){size=14}
            if(size>36){size=36}
        } while(this.$refs.lt.scrollHeight>maxHeight);
    },
    methods: {
        goenter() {
            window.location.href = this.$managePath
        },
        logout() {
            this.$confirm('确定要退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '退出成功!'
                })
                //确认退出，清除token
                this.clearAuthor()
            })
        },

        trainEnter() {
            this.$router.push('/trainenter')
        },
        stuenter() {
            this.$router.push('/student/login')
        },
        search() {
            if (!this.timer) {
                this.timer = setInterval(() => {
                    clearInterval(this.timer)
                    this.timer = null
                    if (this.selected == 2) {
                        this.selected = this.optionList[1].id
                        this.$emit('change', this.topKeyword)

                        localStorage.setItem('select', this.selected)
                        this.$router.push({ path: '/school' })
                    } else if (this.selected == 3) {
                        this.selected = this.optionList[2].id
                        this.$emit('change', this.topKeyword)
                        localStorage.setItem('select', this.selected)
                        this.$router.push({ path: '/skill' })
                    } else {
                        this.selected = this.optionList[0].id
                        localStorage.setItem('select', this.selected)
                        this.$router.push({
                            name: 'search',
                            query: { keyword: this.topKeyword }
                        })
                    }
                }, 1000)
            }
        },
        mouseEnter() {
            this.$emit('mouse-enter')
        },
        mouseLeave() {
            this.$emit('mouse-leave')
        },
        toIndex() {
            this.$router.push('/')
        }
    },
    watch: {
        keyword() {
            this.topKeyword = this.keyword
        },
        selected(newValue, oldValue) {
            this.selected = newValue
        }
    }
}
</script>
<style scoped>
@import '../assets/css/common.css';
.header-down {
    width: 100px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.down {
    width: 20px;
    height: 20px;
    margin-right: 0 !important;
}
.down img {
    width: 20px;
    height: 20px;
    margin-top: 15px;
}
.logo_title {
    width: 440px;
    color: #ad0521 !important;
    font-weight: 600 !important;
}
.search {
    margin-top: 12px;
    margin-left: 350px;
}
#select {
    width: 80px;
    height: 36px;
    position: absolute;
    left: 10px;
    border: none;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: transparent;
    z-index: 3;
}
#select option {
    text-align: center;
}
span.btn {
    cursor: pointer;
}
.allnav {
    width: 100%;
    height: 40px;
    background: #eee;
}
.in_allnav {
    width: 1184px;
    height: 40px;
    /* background: #ccc; */
    margin: 0 auto;
}
.in_allnav span {
    float: left;
    line-height: 40px;
    cursor: pointer;
}
.in_allnav span:nth-child(1):hover {
    color: #3ab57f;
}
.box2 a {
    color: #3ab57f;
}
.islogin {
    margin-left: 30px;
}
.logout {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/top.vue